import React, { useCallback } from 'react'
import clss from 'classnames'
import styled from 'styled-components'

const TextareaStyled = styled.div`
  position: relative;
  textarea {
    height: 48px;
    border: 1px solid #3a3939;
    border-radius: 4px;
    outline: none;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #ffffff;
    transition: all 2;
    width: 100%;
    resize: none;
    background: #141414;
    padding: 12px;
    outline: none;
    &:focus {
      border-color: #e0c286;
    }
    &.error {
      border-color: #ec404e;
    }
  }
  .countdown-box {
    position: absolute;
    right: 12px;
    bottom: 15px;
    color: #6b6b6b;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
  }
  .error-msg {
    position: absolute;
    top: calc(100% + 4px);
    right: 2px;
    text-align: right;
    color: #ec404e;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
`
type TextareaProps<T> = {
  value?: T
  onChange?: (val: T) => void
  onBlur?: () => void
  className?: string
  maxLength?: number
  error?: string
  placeholder?: string
  countdown?: number // 字数倒数优先于maxLength
}
const Textarea = <T extends string | number>(props: TextareaProps<T>) => {
  const { error, maxLength, value, onChange, onBlur, className, placeholder, countdown } = props

  const handleBlur = useCallback(() => {
    onBlur && onBlur()
  }, [onBlur])

  return (
    <TextareaStyled className={className}>
      <textarea
        placeholder={placeholder}
        className={clss({ error: error })}
        maxLength={countdown || maxLength}
        value={value}
        onBlur={handleBlur}
        onChange={e => onChange && onChange(e.target.value as T)}
      />
      {countdown && (
        <div className="countdown-box">
          <span>{String(value || '')?.length}</span>/<span>{countdown}</span>
        </div>
      )}
      {error && <div className="error-msg">{error}</div>}
    </TextareaStyled>
  )
}

export default Textarea
